/**
 * Created by intellicar-rinas on 12/9/17.
 */

export const GEO_HOST = "https://address.intellicar.in";

const remoteApiHost = process.env.REACT_APP_REMOTE_HOST;
const remoteMQTTHost = process.env.REACT_APP_WS_HOST;

// const localApiHost = "https://apiplatform.intellicar.in";

const localApiHost = "https://apiplatform.intellicar.in";
// const localApiHost = "https://staging-apiplatform.intellicar.in";

const localMQTTHost = "https://statsapiplatform.intellicar.in";

/*
 *   ubuntu - firefox = layer
 *   ubuntu - chrome = layer/offset
 *   mac - firefox = layer
 *   mac - chrome = offset
 * */

let platform = navigator.platform;
let userAgent = navigator.userAgent;

export let graphOffsetKey = "layer";
if (platform.toLowerCase().indexOf("mac")) {
  if (userAgent.toLowerCase().indexOf("firefox") !== -1) {
    graphOffsetKey = "layer";
  } else {
    graphOffsetKey = "offset";
  }
}

export let API_HOST = remoteApiHost;
export let MQTT_HOST = remoteMQTTHost;

if (window.location.href.indexOf("localhost") !== -1) {
  API_HOST = localApiHost;
  MQTT_HOST = localMQTTHost;
  console.info("Running App Locally, HOST: ", API_HOST, " - MQTT: ", MQTT_HOST);
}

export const schemaTypes = {
  MULTI_SELECT: "MULTI_SELECT",
  DATE_PICKER: "DATE_PICKER",
  BUTTON: "BUTTON",
  IN_TABLE: "IN_TABLE",
  IN_GRAPH: "IN_GRAPH",
  IN_GRAPH_CONTROL: "IN_GRAPH_CONTROL",
  IN_GRAPH_SET: "IN_GRAPH_SET",
  INPUT: "INPUT",
  INPUT_NUMBER: "INPUT_NUMBER",
  IN_PIE_CHART: "IN_PIE_CHART",
  MOBILEYE_REPORT_TOOLBAR: "MOBILEYE_REPORT_TOOLBAR",
  INFO: "INFO",
  ADVANCED_FUEL_REPORT: "ADVANCED_FUEL_REPORT",
  IN_GREY_SPOTTER: "IN_GREY_SPOTTER",
  AGGREGATED_REPORT: "AGGREGATED_REPORT",
  TVS_REPORT_WIDGET: "TVS_REPORT_WIDGET",
  EV_REPORT: "EV_REPORT",
  IN_BAR_GRAPH: "IN_BAR_GRAPH",
  RAILWAY_REPORT_WIDGET: "RAILWAY_REPORT_WIDGET",
  TRIP_DETAILS_WIDGET: "TRIP_DETAILS_WIDGET",
  TOGGLE: "TOGGLE",
  TOGGLE2: "TOGGLE2",
  SWIGGY_WIDGET: "SWIGGY_WIDGET",
  DOWNLOAD_REPORT: "DOWNLOAD_REPORT",
  UTILIZATION_REPORT: "UTILIZATION_REPORT",
  CANDATA_REPORT: "CANDATA_REPORT",
  DATE_PICKER2: "DATE_PICKER2",
  GROUP_REPORT: "GROUP_REPORT",
  CMD_STATUS_REPORT: "CMD_STATUS_REPORT",
  TRIP_WISE_REPORT: "TRIP_WISE_REPORT",
  ENERGY_CONSUME_REPORT: "ENERGY_CONSUME_REPORT",
    GROUP_SELECT: "GROUP_SELECT",
};

export const dateFormat = "DD-MMM-YYYY HH:mm";
export const dateFormatWithSec = "DD-MMM-YYYY HH:mm:ss";
export const timeFormat = "HH:mm";
export const simpleTimeFormat = "DD-MMM-YYYY";

export const vehicleStates = {
  STOPPPED: "STOPPPED",
  RUNNING: "RUNNING",
  IMMOBILIZED: "IMMOBILIZED",
  DEVICE_PULLOUT: "DEVICE_PULLOUT",
  NON_COMM: "NON_COMM",
  concox_assettracker_charging: "concox_assettracker_charging",
};

export const fuelTypeMap = {
  D: "diesel",
  P: "petrol",
};

const statsKeyMap = {
  0: "onroad",
  1: "offroad",
  2: "allvehicles",
  3: "running",
  4: "stopped",
  5: "immobilized",
  6: "nocomm",
  7: "devicepullout",
  8: "nocomm-kle",
  9: "panicButton",
  10: "mil",
  11: "tampered",
  12: "badBatteryHealth",
  17: "badBatteryHealth-bad",
  18: "badBatteryHealth-avg",
  19: "badBatteryHealth-good",
  20: "never-comm-gps",
  21: "location-zero",
  22: "soc_1_25",
  23: "soc_25_50",
  24: "soc_50_75",
  25: "soc_75_100",
  26: "soc_100",
  27: "btt_1_15",
  28: "btt_15_30",
  29: "btt_30_45",
  30: "btt_a_45",
  31: "curentlycharging",
  32: "apiSubExpired",
  33: "no_soc",
  34: "no_temp",
  35: "SOC_0",
  36: "SOC_NEG",
  37: "BTT_0",
  38: "BTT_NEG",
  39: "CLT_NA",
  40: "CLT_NEG",
  41: "CLT_0",
  42: "CLT_1_15",
  43: "CLT_15_30",
  44: "CLT_30_45",
  45: "CLT_A_45",
  46: "lock",
  47: "unlock",
  48: "immobpullout"
};

let statsIDKeyMap = {};

for (let id in statsKeyMap) {
  statsIDKeyMap[statsKeyMap[id]] = parseInt(id, 10);
}

export const statsIDToKey = (id) => statsKeyMap[id];
export const statsKeyToID = (key) => statsIDKeyMap[key];
export const googleMapAPIKey = "AIzaSyCtWE4hkZml07egPRY08Pc-1_l_zRQxMoE";

export const evAnalyticsColor = [
  "#16b87d",
  "#bc1b45",
  "#871795",
  "#c8551b",
  "#c5da1a",
  "#1a8ecf",
  "#984620",
  "#a0b831",
  "#173ec1",
  "#626262",
  "#0f5c24",
  "#dd867c",
  "#46b8d3",
  "#dbd780",
];
